import {
  Autocomplete,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import { AccountingActionLabel } from "../accounting-action-labels";

export const AccountingActionPreferenceSelect = ({
  action,
  value,
  onChange,
  options,
}) => {
  return (
    <FormControl variant="standard" fullWidth sx={{ pt: 3.5 }}>
      <InputLabel
        shrink
        sx={{
          fontSize: "0.875rem",
          lineHeight: "1.125rem",
          transform: "scale(1)",
        }}
      >
        {AccountingActionLabel[action]}
      </InputLabel>
      <Autocomplete
        value={value || null}
        onChange={(_, newValue) => onChange(newValue)}
        options={options}
        getOptionLabel={(option) => `${option.code} - ${option.name}`}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField {...params} placeholder="Pilih Akun" />
        )}
      />
    </FormControl>
  );
};

AccountingActionPreferenceSelect.propTypes = {
  action: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};
